module.exports = __webpack_public_path__ + "img/head_share_aktiv2.073879b1.png";